import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router';
import { Button } from '@material-ui/core';
import { Loader } from '../../atoms';
import { createPermitFee } from '../../api/fees';
import SearchInput from '../../Components/TableWithFilters/SearchInput';
import usePermitFeesRows from './usePermitFeesRows';

const PermitFeesForm1 = ({ setIsMoreThanMillion, setIsSubmitting, showSuccessModal, handleCloseModal }) => {
  // @ts-ignore
  const { projectId, permitId } = useParams();
  const { rows, setRows, updateCheck, allRows, isFetching, isFetchingData } = usePermitFeesRows(projectId);

  const onChange = (e, index) => {
    const { name } = e.target;
    const { value } = e.target;
    let _rows = [];
    if (name === 'check') {
      const _checked = e.target.checked;
      _rows = rows.map((fee, ndx) => {
        if (ndx === index) {
          updateCheck(fee.feeSettings, _checked);
          return {
            ...fee,
            isChecked: _checked,
          };
        }

        return fee;
      });
    } else {
      if (isNaN(value)) {
        return;
      }

      if (name === 'quantity' && value.indexOf('.') > -1) {
        return;
      }
      _rows = rows.map((fee, ndx) => {
        if (ndx === index) {
          return {
            ...fee,
            [name]: value,
          };
        }

        return fee;
      });
    }

    setRows(_rows);
  };

  const onCheckAll = e => {
    const _checked = e.target.checked;
    const _rows = rows.map((fee, ndx) => {
      return {
        ...fee,
        isChecked: _checked,
      };
    });
    setRows(_rows);
  };

  const addDisabled = () => {
    return !(rows.filter(r => r.isChecked).length > 0);
  };

  const onBlur = (e, index) => {
    const { value } = e.target;
    const _rows = rows.map((fee, ndx) => {
      if (ndx === index) {
        return {
          ...fee,
          amount: Number(value).toFixed(2),
        };
      }

      return fee;
    });
    setRows(_rows);
  };
  const onAdd = () => {
    const selected = allRows.filter(r => r.isChecked);
    const totalAmountFees = selected.reduce((previousValue, currentValue) => {
      previousValue += Number(currentValue.amount) * Number(currentValue.quantity);
      return previousValue;
    }, 0);

    if (totalAmountFees > 99999.0) {
      setIsSubmitting(false);
      setIsMoreThanMillion(true);

      return;
    }

    selected.forEach(async fee => {
      await createPermitFee({
        permit: permitId,
        name: fee.name,
        amount: fee.amount,
        feeSettings: fee.feeSettings,
        quantity: fee.quantity,
      });
    });

    showSuccessModal(true);
    handleCloseModal();
  };
  return (
    <Wrapper>
      <Search>
        <Label>Search:</Label>
        <SearchInput name="global" />
      </Search>

      <Row noMargin>
        <input type="checkbox" onChange={onCheckAll} />
        <HeaderCell>Fee Name</HeaderCell>
        <HeaderCell>Amount</HeaderCell>
        <HeaderCell>Fee Service Type</HeaderCell>
        <HeaderCell>Quantity</HeaderCell>
      </Row>
      <Table>
        {!(isFetching || isFetchingData) ? (
          <div>
            {rows.map((fee, ndx) => (
              <Row key={ndx}>
                <div>
                  <input type="checkbox" name="check" checked={fee.isChecked} onChange={e => onChange(e, ndx)} />
                </div>
                <Cell enabled={fee.isChecked} left>
                  {fee.name}
                </Cell>
                <Cell enabled={fee.isChecked}>
                  <input
                    type="text"
                    value={fee.amount}
                    name="amount"
                    disabled={!fee.isChecked}
                    onChange={e => onChange(e, ndx)}
                    onBlur={e => onBlur(e, ndx)}
                  />
                </Cell>
                <Cell enabled={fee.isChecked} left>
                  {fee.serviceType}
                </Cell>
                <Cell enabled={fee.isChecked}>
                  <input type="text" value={fee.quantity} name="quantity" disabled={!fee.isChecked} onChange={e => onChange(e, ndx)} />
                </Cell>
              </Row>
            ))}
          </div>
        ) : (
          <LoaderCenter>
            <Loader />
          </LoaderCenter>
        )}
      </Table>
      <Buttons>
        <Button disabled={addDisabled()} color="primary" variant="contained" onClick={onAdd}>
          Add
        </Button>
      </Buttons>
    </Wrapper>
  );
};

export default PermitFeesForm1;

const Search = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-3);
  padding: 0 0 var(--space-3);
`;

const Label = styled.div`
  font-size: var(--fs-sm);
  font-weight: var(--fw-medium);
  color: var(--neutral-600);
`;

const LoaderCenter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: var(--space-8) 0;
`;

const Wrapper = styled.div`
  width: 100%;
`;

const Table = styled.div`
  max-height: 50vh;
  overflow-y: auto;
  border: 1px solid var(--neutral-200);
  border-radius: var(--radius-md);
`;

const Row = styled.div<{ noMargin?: boolean }>`
  display: grid;
  grid-template-columns: 48px 1fr 100px 160px 80px;
  align-items: center;
  padding: var(--space-3) var(--space-2);
  border-bottom: 1px solid var(--neutral-100);
  transition: background-color var(--motion-fast) var(--ease-standard);

  ${({ noMargin }) => noMargin && `
    background: var(--neutral-50);
    border-bottom: 2px solid var(--neutral-200);
    position: sticky;
    top: 0;
    z-index: 1;
  `}

  &:hover {
    background: var(--primary-50);
  }

  &:last-child {
    border-bottom: 0;
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: var(--primary-600);
    cursor: pointer;
    margin: 0 auto;
  }
`;

const HeaderCell = styled.div`
  font-size: var(--fs-sm);
  font-weight: var(--fw-semibold);
  color: var(--neutral-500);
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

const Cell = styled.div<{ left?: boolean; enabled: boolean }>`
  font-size: var(--fs-base);
  color: ${({ enabled }) => enabled ? 'var(--neutral-900)' : 'var(--neutral-400)'};
  text-align: ${({ left }) => (left ? 'left' : 'center')};
  padding-left: ${({ left }) => (left ? 'var(--space-2)' : '0')};

  input {
    width: 70px;
    height: 32px;
    padding: 0 var(--space-2);
    border: 1px solid var(--neutral-300);
    border-radius: var(--radius-sm);
    font-size: var(--fs-sm);
    font-family: inherit;
    text-align: right;
    color: var(--neutral-800);
    background: var(--neutral-0);
    transition: border-color var(--motion-fast) var(--ease-standard);

    &:focus {
      outline: none;
      border-color: var(--primary-600);
      box-shadow: var(--shadow-focus);
    }

    &:disabled {
      background: var(--neutral-100);
      color: var(--neutral-400);
      cursor: not-allowed;
    }
  }
`;

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  padding: var(--space-4) 0 var(--space-2);

  button {
    min-width: 160px;
  }
`;
